var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapFonce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    viewBox: "124.66 58.02 183.04 273.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#085244;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.17,58.27c-50.4,0-91.26,40.86-91.26,91.26,0,78.56,62.17,138.04,83.89,156.42,4.26,3.61,10.5,3.61,14.76,0,21.72-18.38,83.89-77.86,83.89-156.42,0-50.4-40.86-91.26-91.26-91.26ZM216.17,208.03c-32.31,0-58.5-26.19-58.5-58.5s26.19-58.5,58.5-58.5,58.5,26.19,58.5,58.5-26.19,58.5-58.5,58.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.17,310.92c0,11.5-26.42,20.82-59,20.82s-59-9.32-59-20.82c0-7.65,11.67-14.33,29.07-17.95,7.45,7.58,14.04,13.47,18.76,17.47,3.12,2.64,7.09,4.09,11.18,4.09s8.06-1.45,11.18-4.09c4.72-4,11.31-9.89,18.76-17.47,17.4,3.62,29.07,10.3,29.07,17.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapFonce);
export default __webpack_public_path__ + "static/media/map_fonce.6efaba13eda52cce260a8b2086c711a1.svg";
export { ForwardRef as ReactComponent };